import { css } from 'styled-components';

export const Truncate = css`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;
